import { StatsRes } from "@wl/types/lib/responses/admin/stats.res";

/**
 * Admin state.
 *
 * @export
 * @interface TabState
 */
export interface AdminState {
    stats: StatsRes | null;
}

/**
 * Initial Admin module state.
 *
 * @return {(() => TabState)}
 */
const state = (): AdminState => ({
    stats: null,
});

export default state;
